import Link from "next/link";
import React, { useContext, useState, useTransition } from "react";
import { useEffect } from "react";
import { Button } from "react-bootstrap";
import helper from "../../lib/helper";
import roleModel from "../../models/roles.model";
import useSWR from "swr";
import ReactPaginate from 'react-paginate';
import { useForm } from 'react-hook-form'
import config from "../../lib/config";
import Heading from "../../components/Heading";

import { useRouter } from "next/router";
import _ from "lodash"
import { groupBy } from "lodash";
const Page = function () {
    const [showLoader, setShowLoader] = useState(false);
    const router = useRouter();

    const { data: permissionsData } = useSWR('permissions', () => roleModel.permission(), config.swrConfig);
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors,isSubmitting },
        setError
    } = useForm();

    const onSubmit = handleSubmit(async (data, event) => {
        const formData = new FormData(event.target);
        await roleModel.create(formData).then((response) => {
            helper.sweetalert.toast(response.data?.message,'success').then(
            router.push('/roles')
        )
        }).catch((error) => {
            helper.sweetalert.toast(error.response.data?.message, 'error');
            _.each(error.response?.data?.errors, function (err, errorKey) {
                setError(errorKey, { type: "required", message: err });
            });
        })
    });

    return (
        <div className="container-fluid">
            <Heading title="Role Create" showLoader={showLoader} />

            <form onSubmit={onSubmit}>
                <div className="card">
                    <div className="card-header">Create</div>
                    <div className="card-body row g-3">
                        <div className="col-md-6">
                            <label htmlFor="inputEmail4" className="form-label">Name</label>
                            <input type="text" className="form-control" id="inputEmail4" {...register('name', { required: "Title is required" })} />
                            {errors.name && <p className='text-danger'>{errors.name.message}</p>}
                        </div>

                    </div>
                    <div className="card-header">Permissions</div>
                    <table className="table table-striped">
                        <tbody>

                            {permissionsData?.data.map((permissionGroup, group) => {
                                return (
                                    <tr>
                                        <th>
                                            {permissionGroup.group_name}
                                            
                                        </th>
                                        <td><label className="form-check">
                                            <input className="form-check-input" {...register(`permissions[]`)} type="checkbox" value={permissionGroup.name} />
                                            {permissionGroup.name}
                                        </label>
                                        </td>
                                    </tr>)
                            })}
                        </tbody>
                    </table>

                    <div className="card-footer">
                        <button type="submit" disabled={isSubmitting ? 'disabled' : ''} className="btn btn-primary float-end">Save</button>
                    </div>
                </div>
            </form>

        </div>
    );
};

export default Page;